import React from 'react';
import './reporting.styles.scss';

const Reporting = () => {
  return (
    <div className="reporting-container">
      <div className="service-header">
        <h1>Database Reporting Services</h1>
        <p>Business intelligence and reporting solutions</p>
      </div>

      <div className="service-content">
        <section className="service-overview">
          <h2>Business Intelligence & Reporting</h2>
          <p>
            Transform your data into actionable insights with our comprehensive reporting 
            and business intelligence solutions. We create custom dashboards, reports, 
            and analytics tools that help you make data-driven decisions.
          </p>
        </section>

        <section className="service-features">
          <h2>Reporting Services Include:</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📈</div>
              <h3>Custom Reports</h3>
              <p>Tailored reports designed to meet your specific business requirements.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Dashboard Creation</h3>
              <p>Interactive dashboards for real-time data visualization and monitoring.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🔍</div>
              <h3>Data Analytics</h3>
              <p>Advanced analytics and data mining to uncover business insights.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3>KPI Tracking</h3>
              <p>Key performance indicator tracking and automated alert systems.</p>
            </div>
          </div>
        </section>

        <section className="contact-section">
          <h2>Ready to Unlock Your Data's Potential?</h2>
          <p>Contact us to discuss your reporting and analytics needs.</p>
          <button className="contact-btn">Get Started</button>
        </section>
      </div>
    </div>
  );
};

export default Reporting;